/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetSession } from 'session-manager-beta';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, convertToNumber } from '../CommonComponents/CustomHooks';
import { InputBox } from '../CommonComponents/InputBox';

const DownloadProcess = () => {
    const inputrefs = useRef([])
    const [timer, setTimer] = useState(0)
    const [subLoading, setSubLoading] = useState(false)
    const [ShowOtpInput, setShowOtpInput] = useState(false)
    const [Response, setResponse] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    let buttonText = GetSession('localStorage', 'buttonValue')
    let ClientCode = GetSession('localStorage', 'ClientCode')
    let EventCode = GetSession('localStorage', 'EventCode')

    const [clientLogo, setClientLogo] = useState('');
    const [clientBanner, setClientBanner] = useState('');
    const [helpLineNo, setHelpLineNo] = useState('');
    const [hText, setHText] = useState('');
    const [formData, setFormData] = useState({
        mobileNo: "",
        emailID: "",
        otp: ''
    })

    const handleSendOtp = async () => {
        try {
            await setFormData({ ...formData, otp: '' })
            await setSubLoading(true)
            let data = await ApiCall(`/api/EventProcess/SendOTP`, { ...formData, EventCode, ClientCode });
            await setSubLoading(false)
            await setResponse(data)
            if (data.status === 'SUCCESS') {
                await setTimer(30);
                await setIsDisabled(true);
                await setShowOtpInput(true);
                await inputrefs.current['txtOTP'].focus()
            } else if (data.status === 'ERROR') {
                await setShowOtpInput(false)
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
            setSubLoading(false)
        }
    };

    function downloadFile(url, fileName) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName || 'download.pdf';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    const handleDownload = async () => {
        try {
            await setSubLoading(true)
            let data = await ApiCall(`/api/EventProcess/DownloadPrint`, { ...formData, EventCode, ClientCode });
            await setSubLoading(false)
            if (data.status === 'SUCCESS') {
                await downloadFile(data.printUrl, 'AdmitCard.pdf');
                await setFormData({
                    mobileNo: "",
                    emailID: "",
                    otp: ''
                })
                await setIsDisabled(false)
                await setResponse(false)
                await setShowOtpInput(false)
                await setTimer(0)
            } else if (data.status === 'ERROR') {
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
            await setSubLoading(false)
        }
    }
    const handleGetClientLogo = async (Type) => {
        try {
            await setSubLoading(true)
            let data = await ApiCall(`/api/EventProcess/GetClientLogo`, { EventCode, ClientCode, Type });
            await setSubLoading(false)
            if (data.status === 'SUCCESS') {
                if (Type === 'ClientLogo') {
                    setClientLogo(data.clientLogo);
                    setClientBanner(data.clientBanner);
                }
                else {
                    setHelpLineNo(data.helpLineNo);
                    setHText(data.hText);
                }
            } 
        } catch (error) {
            console.error('Error GetClientLogo:', error);
        } finally {
            await setSubLoading(false)
        }
    }

    useEffect(() => {
        document.title = 'Download Process';
        handleGetClientLogo("ClientLogo");
        handleGetClientLogo("HelpLineNo");
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
        }
        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    return (
        <>
            {subLoading &&
                <BlurLoader />}
            <section className="detail-form">
                <div className="container">
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="col-lg-10">
                            <div className="police-st">
                                {/*<div className=" d-flex justify-content-center">*/}
                                {/*    <span>*/}
                                {/*        <img*/}

                                {/*            src={clientLogo ? clientLogo : ''}*/}
                                {/*            alt=""*/}
                                {/*            className="img-fluid"*/}
                                {/*        />*/}
                                {/*    </span>*/}
                                {/*    <Link className="navbar-brand" to="/OnlineManagementSystem">*/}
                                {/*        <img*/}

                                {/*            src={clientBanner ? clientBanner : ''}*/}
                                {/*            className="img-fluid"*/}
                                {/*        />*/}
                                {/*    </Link>*/}
                                {/*</div>*/}
                                <div className="details-form details-form-mrg">
                                    <div className="row">
                                        <p className='text-center fs-4 fw-bold text-dark m-1 mb-3'>
                                            {buttonText}
                                        </p>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="mt-1">
                                                <div className="row">
                                                    <label className="col-md-4 col-form-label">
                                                        Please Enter your Mobile No
                                                    </label>
                                                    <InputBox
                                                        id="txtMobileNo"
                                                        placeholder="Mobile No"
                                                        divclassname="col-md-8 mb-2"
                                                        inputclassname="downloadForm"
                                                        disabled={formData.emailID}
                                                        maxLength='10'
                                                        value={formData.mobileNo}
                                                        onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value), emailID: '' })}
                                                        inputrefs={inputrefs}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputrefs.current['txtEmailID'].focus()
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-1">
                                                <div className="row">
                                                    <label className="col-md-4 col-form-label">
                                                        Please Enter your Email ID
                                                    </label>
                                                    <InputBox
                                                        id="txtEmailID"
                                                        placeholder="Email ID"
                                                        divclassname="col-md-8 mb-2"
                                                        inputclassname="downloadForm"
                                                        maxLength='50'
                                                        value={formData.emailID}
                                                        disabled={formData.mobileNo}
                                                        onChange={(e) => setFormData({ ...formData, emailID: e.target.value, mobileNo: '' })}
                                                        inputrefs={inputrefs}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleSendOtp()
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <div className="row">
                                                    <div className="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center gap-2 justify-content-end">
                                                        {ShowOtpInput && <>
                                                            <span style={{ color: 'var(--text)' }}>
                                                                Didn't receive an OTP?
                                                                <button
                                                                    type="button"
                                                                    onClick={handleSendOtp}
                                                                    id='btnSub'
                                                                    ref={ref => (inputrefs.current['btnSub'] = ref)}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        color: '#007bff',
                                                                        fontWeight: 'bold',
                                                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                        marginLeft: '7px',
                                                                        opacity: isDisabled ? 0.5 : 1,
                                                                    }}
                                                                    disabled={isDisabled}
                                                                >
                                                                    {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                                                </button>
                                                            </span>
                                                        </>}
                                                        <button
                                                            className="printbutton btn"
                                                            type="button"
                                                            id="btnOTP"
                                                            disabled={isDisabled}
                                                            onClick={handleSendOtp}
                                                            style={{ color: "black" }}
                                                        >
                                                            <i className="fa fa-send-o" /> Get OTP
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {ShowOtpInput && <>
                                                <div className="mt-3">
                                                    <div className="row">
                                                        <label className="col-md-4 col-form-label">
                                                            Please Enter 6 digit OTP <span className="required">*</span>
                                                        </label>
                                                        <InputBox
                                                            id="txtOTP"
                                                            placeholder="OTP"
                                                            divclassname="col-md-8 mb-2"
                                                            inputclassname="downloadForm"
                                                            maxLength='6'
                                                            value={formData.otp}
                                                            onChange={(e) => setFormData({ ...formData, otp: convertToNumber(e.target.value) })}
                                                            inputrefs={inputrefs}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    inputrefs.current['txtEmailID'].focus()
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-xs-12 text-center mb-2">
                                                            {isDisabled &&
                                                                <label className={'text-success fw-bold fs-6'}>{Response.message}</label>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <button
                                                                className="printbutton btn"
                                                                type="button"
                                                                id="btnPrint"
                                                                onClick={handleDownload}
                                                                style={{ color: "black" }}
                                                            >
                                                                <i className="fa fa-print" /> {buttonText}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            }
                                            <div className="mt-4">
                                                <div className="row">
                                                    <div
                                                        className="col-md-12 col-sm-12 col-xs-12 lblError"
                                                        style={{ borderRadius: 5 }}
                                                    >
                                                        <div
                                                            style={{ height: 46, backgroundColor: "#163886" }}
                                                            className="lblError text-center pt-1 mt-4 fs-4 text-light"
                                                        >
                                                             {helpLineNo === "" ? "" : hText +" : "+ helpLineNo}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default DownloadProcess;